// eslint-disable-next-line import/no-extraneous-dependencies
import 'modern-css-reset/dist/reset.min.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import useThemeStore from './stores/theme';
import './styles/global.styl'; // Importer les styles globaux

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);

// Le thème doit être connu avant le premier rendu pour charger directement le bon logo
useThemeStore(pinia).initialiserTheme();

router.isReady().then(() => {
  app.mount('#app');
});
